import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Adobe from '../../img/agenda/Adobe.png'
import Brissac from '../../img/agenda/Brissac.png'
import google from '../../img/agenda/google.png'
import Ivana from '../../img/agenda/Ivana.png'
import Microsoft from '../../img/agenda/Microsoft.png'
import tblx from '../../img/agenda/tblx.png'
import Sava from '../../img/agenda/Sava.png'
import Savytskyi from '../../img/agenda/Savytskyi.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:10',
                    day: 'Tuesday, May 02',
                    photo: Brissac,
                    name: 'Laszlo de Brissac',
                    position: 'Product Manager',
                    ln: 'https://www.linkedin.com/in/laszlo-de-brissac-108231a9/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=How+to+PM+a+fantasy+novel&dates=20230502T091000Z/20230502T094000Z&details=The+PMing+skills+we+use+in+our+day+to+day+jobs+in+tech+can+be+applied+to+any+kind+of+other+areas+--%3E+including+publishing+a+fantasy+novel.+Outside+of+my+work+at+Google+I+have+collaborating+with+a+team+of+artists+(ghostwriters,+illustrators,+critics,+editors)+to+bring+my+vision+for+a+story+to+life.+The+book+(The+Night+Streamer+available+on+Amazon)+has+been+published+last+year+and+received+thousands+of+sales.Through+this+talk+I+am+showing+how+to+apply+the+key+pillars+of+PMing+to+any+project:-+Knowing+your+users+and+their+needs-+Rallying+a+team+around+one+vision+to+execute+on+it-+The+importance+of+iterating+testing&location=online',
                    logo: google,
                    title: 'How to PM a fantasy novel',
                    abstract: `The PMing skills we use in our day to day jobs in tech can be applied to any kind of other areas --> including publishing a fantasy novel. Outside of my work at Google I have collaborating with a team of artists (ghostwriters, illustrators, critics, editors) to bring my vision for a story to life. The book (The Night Streamer available on Amazon) has been published last year and received thousands of sales.

                    Through this talk I am showing how to apply the key pillars of PMing to any project:
                    - Knowing your users and their needs
                    - Rallying a team around one vision to execute on it
                    - The importance of iterating testing`,
                },
                {
                    time: '09:40',
                    day: 'Tuesday, May 02',
                    photo: Sava,
                    name: 'Valeria Sava',
                    position: 'Product Manager',
                    ln: 'https://www.linkedin.com/in/valeria-sava/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=World-class+Product+Managers,+path+demystified&dates=20230502T094000Z/20230502T101000Z&details=In+this+session,+you+will+find+about+how+to+become+and+prepare+for+a+Product+Manager+role+with+practical+tips,+but+also+how+to+strive+for+bettering+yourself+in+the+process+of+making+and+improving+any+technology+product+in+the+market.&location=online',
                    logo: Microsoft,
                    title: 'World-class Product Managers, path demystified',
                    abstract: `In this session, you will find about how to become and prepare for a Product Manager role with practical tips, but also how to strive for bettering yourself in the process of making and improving any technology product in the market.`,
                },
                {
                    time: '10:10',
                    day: 'Tuesday, May 02',
                    photo: Ivana,
                    name: 'Alexandru Ivana',
                    position: 'Product Manager',
                    ln: 'https://www.linkedin.com/in/alexandru-ivana-ba982663/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=How+to+measure+outcomes+not+outputs+&dates=20230502T101000Z/20230502T104000Z&details=I+want+to+share+from+my+experience+what+made+my+product+team+successful.+As+I+work+with+many+engineering+teams+spread+across+multiple+regions+and+also+many+other+dependent+teams+are+rarely+together.+In+order+to+deliver+the+impact+that+Adobe+requires+the+need+of+thinking+about+outcomes+is+vital.+In+the+talk+I+want+to+share+my+framework+++metrics+to+measure+the+succes.+But+also+some+nice+tips+about+multi+geo+and+culture+collaboration.&location=online',
                    logo: Adobe,
                    title: 'How to measure outcomes not outputs',
                    abstract: `I want to share from my experience what made my product team successful. As I work with many engineering teams spread across multiple regions and also many other dependent teams are rarely together. In order to deliver the impact that Adobe requires the need of thinking about outcomes is vital. In the talk I want to share my framework + metrics to measure the succes. But also some nice tips about multi geo and culture collaboration.`,
                },
                {
                    time: '10:40',
                    day: 'Tuesday, May 02',
                    photo: Savytskyi,
                    name: 'Nikita Savytskyi',
                    position: 'Principal Product Manager and Service Designer',
                    ln: 'https://www.linkedin.com/in/mykytoz/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=How+to+scale+your+product+management+team&dates=20230502T104000Z/20230502T111000Z&details=It+is+naive+to+expect+that+to+grew+a+PM+in-house+you+only+need+to+find+a+bright+colleague,+promote+to+Product+Manager+position+and+feed+%22Inspired%22+to+that+person+-+it+takes+a+bit+more+than+that+:)&location=online',
                    logo: tblx,
                    title: 'How to scale your product management team',
                    abstract: `It is naive to expect that to grew a PM in-house you only need to find a bright colleague, promote to Product Manager position and feed "Inspired" to that person - it takes a bit more than that :)`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/pm?track=1631629650618x741924358041370600' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};